export const MAX_ACCOUNTANT_COMPANIES = 500;
